'use strict';

import axios from 'axios';
import config from 'config';

const API_SERVER = config['quotes_api'] || 'https://quote.fxclub.org/';
let request = axios.create({
    baseURL: API_SERVER
});

// http://phalcon-widget-gornov.web2.dev.fxclub.org/info/en?s=Bitcoin,FDAX&i=D1&f=market
export function getInstruments (lang = 'en', { symbols, fields, intervals, markets }) {
    const params = {
        intervals: (intervals || ['D1']).join(','),
        fields: (fields || ['market']).join(','),
        symbols: (symbols || []).join(','),
        markets: (markets || []).join(',')
    };

    return request.get(`/info/${lang}`, { params }).then((response) => {
        return response.data.data;
    });
}



// WEBPACK FOOTER //
// ./src/api/web-sdk.js